import React, { useState } from "react";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaInfoCircle,
  FaFacebookF,
  FaLinkedin,
  FaYoutube,
  FaMailBulk,
  FaBars,
  FaTimes,
  FaBell,
  FaBook,
  FaExclamationCircle,
  FaBriefcase,
} from "react-icons/fa";
import { FaBuildingUser } from "react-icons/fa6";
import { TbRefresh } from "react-icons/tb";
import SecondRow from "./secondRow"; // Import Second Navbar
import "./css/firstRow.css";
import "./css/secondRow.css";

const TopNavBar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false); // State to manage menu visibility

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen); // Toggle menu state
  };

  return (
    <>
      {/* First Navbar */}
      <div className="top-nav-bar">
        <div className="left-nav"></div>

        {/* Hamburger Icon for Small Screens */}
        <div className="hamburger" onClick={toggleMenu}>
          {isMenuOpen ? (
            <FaTimes className="icon" />
          ) : (
            <FaBars className="icon" />
          )}
        </div>

        {/* Right Navigation Menu */}

        <div className={`right-nav ${isMenuOpen ? "open" : ""}`}>
          {/* <div className="nav-item">
            <a
              href="http://xgascloud.com/xcems_en/English/"
              style={{ textDecoration: "none", color: "white" }} 
            >
              <TbRefresh className="icon" />
              <span
                style={{
                  fontFamily: "'Poppins', sans-serif FaInfoCircle",
                  fontWeight: 400,
                  fontSize: "12px",
                }}
              >
                Air Quality Monitor
              </span>
            </a>
          </div> */}
          <div className="nav-item nav-high">
            <FaPhoneAlt className="icon" />
            <span
              style={{
                fontFamily: "'Poppins', sans-serif",
                fontWeight: 400,
                fontSize: "12px",
              }}
            >
              Toll Free Number: 462
            </span>
          </div>
          <div className="nav-item nav-high">
            <FaInfoCircle className="icon" />
            <span
              style={{
                fontFamily: "'Poppins', sans-serif FaInfoCircle",
                fontWeight: 400,
                fontSize: "12px",
              }}
            >
              Tip-Offs Anonymous: 847
            </span>
          </div>
          <div className="nav-item nav-high">
            <a
              href="https://cloudmail.synaq.com"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none", color: "white" }}
            >
              <FaMailBulk className="icon" />
              <span
                style={{
                  fontFamily: "'Poppins', sans-serif",
                  fontWeight: 400,
                  fontSize: "12px",
                }}
              >
                Webmail
              </span>
            </a>
          </div>
          {/* <div className="nav-item">
            <a
              href="http://192.168.0.5:3000/#/dashboard"
              style={{ textDecoration: "none", color: "white" }}
            >
              <FaBuildingUser className="icon" />
              <span
                style={{
                  fontFamily: "'Poppins', sans-serif FaInfoCircle",
                  fontWeight: 400,
                  fontSize: "12px",
                }}
              >
                Intranet
              </span>
            </a>
          </div> */}

          <div className="nav-item nav-medium">
            <FaEnvelope className="icon" />
            <span
              style={{
                fontFamily: "'Poppins', sans-serif",
                fontWeight: 400,
                fontSize: "12px",
              }}
            >
              <a
                href="mailto:mbs@mbsmw.org"
                style={{
                  textDecoration: "none",
                  color: "white",
                }}
              >
                mbs@mbsmw.org
              </a>
            </span>
          </div>
          {/* <div className="nav-item">
            <FaBook className="icon" />
            <span
              style={{
                fontFamily: "'Poppins', sans-serif",
                fontWeight: 400,
                fontSize: "12px",
              }}
            >
              <Link
                to="/NationalCodex"
                style={{ textDecoration: "none", color: "white" }}
              >
                National Codex
              </Link>
            </span>
          </div> */}

          <div className="nav-item nav-low">
            <FaBell className="icon" />
            <span
              style={{
                fontFamily: "'Poppins', sans-serif",
                fontWeight: 400,
                fontSize: "12px",
              }}
            >
              <Link
                to="/Alerts"
                style={{ textDecoration: "none", color: "white" }}
              >
                Alerts
              </Link>
            </span>
          </div>
          <div className="nav-item nav-low">
            <a
              href="http://192.168.0.5:8004/staff-tools-login" // Laravel login URL
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none", color: "white" }}
            >
              <FaMailBulk className="icon" />
              <span
                style={{
                  fontFamily: "'Poppins', sans-serif",
                  fontWeight: 400,
                  fontSize: "12px",
                }}
              >
                Staff Tools
              </span>
            </a>
          </div>

          <div className="nav-item notice nav-high">
            <FaExclamationCircle className="icon" />
            <span
              style={{
                fontFamily: "'Poppins', sans-serif",
                fontWeight: 400,
                fontSize: "12px",
              }}
            >
              <Link
                to="/PublicNotices"
                style={{ textDecoration: "none", color: "white" }}
              >
                Public Notices
              </Link>
            </span>
          </div>

          <div className="nav-item dropdown nav-high">
            <a
              className="nav-link dropdown-toggle"
              href="#"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              style={{ color: "white", textDecoration: "none" }}
            >
              <FaBriefcase className="icon" />
              <span
                style={{
                  fontFamily: "'Poppins', sans-serif",
                  fontWeight: 400,
                  marginLeft: 5,
                  fontSize: "12px",
                }}
              >
                Opportunities
              </span>
            </a>

            <ul className="dropdown-menu">
              <li>
                <Link className="dropdown-item" to="/careers">
                  Careers
                </Link>
              </li>
              <li>
                <Link className="dropdown-item" to="/procurement">
                  Procurement
                </Link>
              </li>
            </ul>
          </div>

          <div className="nav-item social-icons">
            <a href="https://www.facebook.com/malawistandardsbureau/">
              <FaFacebookF className="social-icon" />
            </a>
            {/* <a href="https://www.youtube.com/">
            <FaYoutube className="social-icon" />
            </a>*/}
            <a href="https://www.linkedin.com/company/malawi-bureau-of-standards/about/">
              <FaLinkedin className="social-icon" />
            </a>
          </div>
        </div>
      </div>

      {/* Hide Second Navbar when First Navbar is Open */}
      {!isMenuOpen && <SecondRow />}
    </>
  );
};

export default TopNavBar;